import * as React from 'react';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import config from '../../../server/config';
import request from '../../../server/request';

export default class AuthEnterprise extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);
        this.state = {
            data: {
                companyBanks: [],
                refundBank: {}
            }, // 企业信息
            status: -1, // 企业认证状态
            viewPicSrc: '' // 大图地址
        }
    }
    public componentDidMount() {
        this.getData();
    }
    public render() {
        const state = this.state;
        return (
            state.status > -1 ?
            ((state.status == 0 || state.status == 1 || state.status == 2 || state.status == 20) && !state.data.company) ?
                <div className="certify">
                    <div className="certify-top">
                        <h2>您尚未通过企业认证，认证后您即可进行交易</h2>
                        <p>如果您所在公司未入驻买化塑平台，请立即认证企业</p>
                        <p>如果您所在公司已入驻买化塑平台，可直接申请加入</p>
                    </div>
                    <div className="certify-btm">
                        <div className="certify-btn">
                            <Link to="#" className="rz" onClick={() => this._checkLogin('/authentication/step1')}>立即认证</Link>
                            <Link to="#" className="join" onClick={() => this._checkLogin('/authentication/join')}>申请加入</Link>
                        </div>
                        <Link to="#" className="record" onClick={() => this._checkLogin('/authentication/apply')}>申请记录</Link>
                    </div>
                </div>
                :
                <div>
                {
                    (state.status == 30 || state.status == 50) && state.data.applyRecode.status == 0 ?
                    <div className="state">
                        <div className="stateing"><img src={require('@/assets/images/state3.png')} /><em>审核中</em></div>
                        <button onClick={() => this.props.history.push('/auth/step1', {actiontype: 4}) }>申请变更</button>
                    </div>
                    : null
                }
                {
                    (state.status == 1 || state.status == 2 || state.status == 20) && state.data.applyRecode && state.data.applyRecode.status == 2 ?
                    <div className="state">
                        <div className="stateing"><img src={require('@/assets/images/state3.png')} /><em>未通过</em></div>
                        <button onClick={() => this.props.history.push('/auth/step1') }>重新认证</button>
                    </div>
                    : null
                }
                {
                    (state.status == 3 || state.status == 5) && state.data ?
                    <div className="state">
                        <div className="stateing"><img src={require('@/assets/images/state3.png')} /><em>已认证</em></div>
                        <button onClick={() => this.props.history.push('/auth/step1', {actiontype: 4}) }>认证变更</button>
                    </div>
                    : null
                }
                {
                    state.status != 40 ?
                    <div>
                    <p className="company-title">工商信息</p>
                    <ul className="company">
                        <li>
                            <div className="company-tit"><b>*</b><p>公司名称</p></div><span className="textmarket">{state.data.company}</span>
                        </li>
                        <li>
                            <div className="company-tit"><b>*</b><p>社会信用代码</p></div><span className="textmarket">{state.data.licenceCreditCode}</span>
                        </li>
                        <li>
                            <div className="company-tit"><p>公司类型</p></div>
                            <div className="Location"><div>{state.data.companyType}</div></div>
                        </li>
                        <li>
                            <div className="company-tit"><p>成立时间</p></div><span className="textmarket">{state.data.establishTime ? moment(state.data.establishTime).format('YYYY-MM-DD') : ''}</span>
                        </li>
                        <li>
                            <div className="company-tit"><p>币种</p></div><span className="textmarket">{state.data.currency}</span>
                        </li>
                        <li>
                            <div className="company-tit"><p>注册资本</p></div><span className="textmarket">{state.data.registeredCapital}万</span>
                        </li>
                        <li>
                            <div className="company-tit"><b>&nbsp;</b><p>法人身份证</p></div><span className="textmarket">{state.data.companyLegalPersonIdCard || ''}</span>
                        </li>
                        <li>
                            <div className="company-tit"><p>公司法人</p></div><span className="textmarket">{state.data.companyLegalPerson}</span>
                        </li>
                        <li>
                            <div className="company-tit"><p>营业期限</p></div>
                            <div className="Location"><div id="selectdate">{state.data.licenceExptimeFlag == 1 ? moment(state.data.licenceExptime).format('YYYY-MM-DD') : '长期'}</div></div>
                        </li>
                        <li>
                            <div className="company-tit"><p>住所</p></div><span className="textmarket">{`${state.data.licenceProvinceName}${state.data.licenceCityName}${state.data.licenceCountyName}${state.data.licenceDetailAddress}`}</span>
                        </li>
                         <li>
                            <div className="company-tit"><b>*</b><p>企业类型</p></div><span className="textmarket">{['经销商', '工厂', '工贸一体'][state.data.companyCategory-1]}</span>
                        </li>
                        <li>
                            <div className="company-tit"><b>*</b><p>经营危险化学品</p></div><span className="textmarket">{state.data.isManageHazardous === 1 ? '是':'否'}</span>
                        </li>
                         {
                            state.data.isManageHazardous === 1 ?
                                <li>
                                    <div className="company-tit"><b>&nbsp;</b><p>许可证到期时间</p></div><span className="textmarket">{state.data.hazardousLicenceExptime ? moment(state.data.hazardousLicenceExptime).format('YYYY-MM-DD') : ''}</span>
                                </li> : ''
                        }
                        {
                            state.data.isManageHazardous === 1 ?
                                <li>
                                    <div className="company-tit"><b>&nbsp;</b><p>危化品经营方式</p></div><span className="textmarket">{state.data.manageHazardousWay || ''}</span>
                                </li> : ''
                        }
                    </ul>
                    <p className="company-title">开票信息</p>
                    {
                       
                        this.state.data.companyBanks && this.state.data.companyBanks[0] ?
                            <ul className="company">
                                <li>
                                    <div className="company-tit"><p>开户银行</p></div><span className="textmarket">{state.data.companyBanks[0].bank}</span>
                                </li>
                                <li>
                                    <div className="company-tit"><p>银行账号</p></div><span className="textmarket">{state.data.companyBanks[0].bankAccountNumber}</span>
                                </li>
                                <li>
                                    <div className="company-tit"><p>联系电话</p></div><span className="textmarket">{state.data.companyBanks[0].phone}</span>
                                </li>
                                <li>
                                    <div className="company-tit"><p>详细地址</p></div><span className="textmarket">{state.data.companyBanks[0].address}</span>
                                </li>
                            </ul> : ''
                    }
                    <p className="company-title">附件信息</p>
                    <ul className="company">
                        <li onClick={() => this.showPic(state.data.licence)}>
                            <div className="company-tit"><b>*</b><p>营业执照</p></div>
                            <div className="camera"><div><img src={require('@/assets/images/choose.png')} alt="" className="chooseImg" /></div></div>
                        </li>
                        {
                            state.data.isManageHazardous === 1 ?
                                <li onClick={() => this.showPic(state.data.hazardousLicence)}>
                                    <div className="company-tit"><b>&nbsp;</b><p>危化品经营许可证</p></div>
                                    <div className="camera"><div><img src={require('@/assets/images/choose.png')} alt="" className="chooseImg" /></div></div>
                                </li> : ''
                        }
                        <li onClick={() => this.showPic(state.data.invoiceInfo)}>
                            <div className="company-tit"><p>开票资料</p></div>
                            <div className="camera"><div><img src={require('@/assets/images/choose.png')} alt="" className="chooseImg" /></div></div>
                        </li>
                        <li onClick={() => this.showPic(state.data.authorization)}>
                            <div className="company-tit"><b>*</b><p>授权书</p></div>
                            <div className="camera"><div><img src={require('@/assets/images/choose.png')} alt="" className="chooseImg" /></div></div>
                        </li>
                        {
                        // <li>
                        //     <div className="company-tit"><b>*</b><p>业务员名称</p></div><span className="textmarket">{state.data.salesmanName}</span>
                        // </li>
                        }
                        <li onClick={() => this.showPic(state.data.logo)}>
                            <div className="company-tit"><b>&nbsp;</b><p>企业LOGO</p></div>
                            <div className="camera"><div><img src={require('@/assets/images/choose.png')} alt="" className="chooseImg" /></div></div>
                        </li>
                    </ul>
                    
                    <div className="recordBox"><Link to={{pathname: '/authentication/apply'}} className="record">申请记录</Link></div>
                    <div className={`views-img ${state.viewPicSrc !== '' ? 'active' : ''}`} onClick={() => this.hidePic()}>
                        <img src={state.viewPicSrc} />
                    </div>
                </div> 
                : <div className="enterprise-tips">当前状态：已提交“加入企业”申请，请联系企业管理员审核，审核通过即可加入企业。</div>
                }
            </div> 
            : <div></div>
        )
    }
    // 获取数据
    private async getData() {
        const r = await request({
            url: `${config.API}member/company/info`
        });
        if(!r.obj) {
            return this.setState({status: 0});
        }
        if(r.code === 1) {
            this.setState({
                data: r.obj.companyInfo || {
                    companyBanks: [],
                    refundBank: {}
                },
                status: r.obj.authStatus
            });
        } 
    }
    /**
     * [查看大图]
     * @param imgId 图片id
     */
    private showPic(imgId: number) {
        if(!imgId) return;
        this.setState({viewPicSrc: config.API + 'image/download/crmAnnex?imgId=' + imgId});
    }
    // 隐藏大图
    private hidePic() {
        this.setState({viewPicSrc: ''});
    }
    /**
    * 重新认证/认证变更
    * @param {boolean} edit 是否重新认证
    * @param {boolean} initData 是否初始化数据
    */
    /*private authAgain(edit?: boolean, initData?: boolean) {
        if(edit) {
            this.props.history.push('/authentication/step1?authtype=1');
        } else if(initData) {
            this.props.history.push('/authentication/step1?init=1');
        } else {
            this.props.history.push('/authentication/step1');
        }   
    }*/
    private async _checkLogin(url: string) {
        const r = await request({
          method: "get",
          url: `${config.WAPAPI}safety/account/get`,
        });
        if(r.code === 1) {
            this.props.history.push(url);
        }
  }
}